import styled from "styled-components"

export const Wrapper = styled.div`
  flex: 1 1 33%;
  padding: ${({theme}) => `${theme.spacing.one}`};
  border: 1px solid ${({theme}) => theme.colors.primary2};
  border-radius: ${({theme}) => theme.spacing.half};
`
